import { useGetAllFieldsQuery } from '../../../store/api/customRequirements.api';
import { FC } from 'react';
import { AnalyticsPage } from './analytics.page';

export const AnalyticsAdminLevelPage: FC = () => <AnalyticsPage isAdminRoute={true} />;
